//angular
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { Router } from '@angular/router';
//app
import { AppAnimations } from '../../../_shared/animations';
import { DataSharingService, StorageService } from '../../../_core/services';

import { Company, RestResponse } from 'src/app/_shared/models';
import { User, UserCompany } from '../../../_shared/models/user.model';
import { SharedGlobalService } from 'src/app/_core/services/api/shared-global.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { CompanyStatus, LoadingState } from 'src/app/app.data';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '', 'class': 'display flex h100vh' }
})

export class SwitchComponent implements OnInit, OnDestroy {

  activeCompanies: any;
  collectionOfPendingCompanies: Array<Company> = [];
  collectionOfUserCompany: Array<UserCompany> = [];
  hasPendingActivation: boolean = false;
  hasUserInformation: boolean = false;
  pendingActivation:any;
  statusLoading = LoadingState.isLoading;
  user: User = new User;
  
  @Input() loadingState = LoadingState;
  private subs = new Unsubscriber();

  constructor(
    private dataService: DataSharingService,
    private iconRegistry: MatIconRegistry,
    private meta: MetaService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private sharedGlobalService: SharedGlobalService,
    private storage: StorageService
  ) {
    this.iconRegistry.addSvgIcon('next', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-next-01.svg'));
    this.iconRegistry.addSvgIcon('logo-rebillia', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/logo-rebillia.svg'));
    this.meta.removeGatewayScripts();
  }

  ngOnInit() {
    this.initData();
  }
  
  initData() {
    this.statusLoading = LoadingState.isLoading;

    this.subs.addSub = this.sharedGlobalService.getCurrentUserProfile().subscribe(
      (res: RestResponse) => {
        this.user = new User().deserialize(res.data);
        this.loadSections();
      },
      (err: RestResponse) => {
        this.router.navigate(['/login']);
      }
    );
  }

  async loadSections() {
    
    this.activeCompanies = await this.sharedGlobalService.getUserCompanies().toPromise();
    this.pendingActivation = await this.sharedGlobalService.getPendingActivationCompanies().toPromise();
    
    if(!(this.activeCompanies?.code !== 200 || this.pendingActivation?.code !== 200 || this.activeCompanies?.data?.length > 0 || this.pendingActivation?.data?.length > 0 )) {
      localStorage.setItem('noHasCompanies', 'true');
      this.router.navigate(['/setup']);
    } else {
      localStorage.setItem('noHasCompanies', 'false');
      this.collectionOfUserCompany = <Array<UserCompany>>this.activeCompanies?.data;
      this.hasUserInformation = this.collectionOfUserCompany?.length > 0;
      this.collectionOfPendingCompanies = (<Array<Company>>this.pendingActivation?.data).filter(company => company.status !== CompanyStatus.closed);
      this.hasPendingActivation = this.collectionOfPendingCompanies?.length > 0;
      this.statusLoading = LoadingState.isLoaded;
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
